<div class="h-100 flex-grow-1 d-flex flex-column">
  <!-- Column headers (md and up only) -->
  <div class="main-panel tx-grid tx-header">
    <span class="tx-h-name">Name</span>
    <span class="tx-h-date">Date</span>
    <span class="tx-h-card">Card Number</span>
    <span class="tx-h-amount">Amount</span>
    <span class="tx-h-status">Status</span>
    <span class="tx-h-go">Action</span>
  </div>

  @if (showSkeleton) {
    <div class="tx-viewport tx-skeleton" data-test="transactions-list-skeleton">
      @for (row of skeletonRows; track row) {
        <div class="main-panel tx-grid tx-row">
          <div class="tx-cell tx-brand"><span class="skel"></span></div>
          <div class="tx-cell tx-channel"><span class="skel"></span></div>
          <div class="tx-cell tx-name">
            <span class="skel skel-line skel-name"></span>
            <span class="skel skel-line skel-sub d-md-none"></span>
          </div>
          <div class="tx-cell tx-date">
            <span class="skel skel-line skel-date-day"></span>
            <span class="skel skel-line skel-date-time"></span>
          </div>
          <span class="tx-cell tx-card"><span class="skel skel-line skel-card"></span></span>
          <span class="tx-cell tx-amount"><span class="skel skel-line skel-amount"></span></span>
          <span class="tx-cell tx-status"><span class="skel skel-pill"></span></span>
          <div class="tx-cell tx-go">
            <div class="skel skel-go d-flex align-items-center justify-content-center">
              <mat-icon>arrow_forward</mat-icon>
            </div>
          </div>
        </div>
        <mat-divider></mat-divider>
      }
    </div>
  } @else {
  <!-- main-panel: the viewport paints the same background as the rows it
       contains. On a hard scroll the compositor can reveal a strip before the
       CDK has rendered the rows for it, and without this the darker bg-panel
       behind the list shows through as a grey flicker. -->
  <cdk-virtual-scroll-viewport
    [itemSize]="rowSize"
    [minBufferPx]="minBufferPx"
    [maxBufferPx]="maxBufferPx"
    class="tx-viewport main-panel"
  >
    <div
      *cdkVirtualFor="
        let transaction of formattedTransactions;
        let i = index;
        trackBy: trackRow
      "
    >
      <div
        (click)="select(transaction)"
        (keydown.enter)="select(transaction)"
        tabindex="0"
        role="button"
        [attr.data-test]="'transaction-item-' + i"
        class="interactive main-panel tx-grid tx-row"
      >
        <!-- Card scheme logo (md and up) -->
        <div class="tx-cell tx-brand">
          <div class="tx-brand-box">
            @if (transaction.cardIcon.iconType === 'ICON') {
              <mat-icon class="d-block">{{ transaction.cardIcon.value }}</mat-icon>
            } @else {
              <img
                class="w-100 h-100 d-block"
                [src]="transaction.cardIcon.value"
                alt="Card scheme logo"
              />
            }
          </div>
        </div>

        <!-- Channel / type -->
        <div
          class="tx-cell tx-channel"
          [matTooltip]="transaction.rowIconTooltip"
          matTooltipPosition="right"
        >
          <fa-icon [icon]="transaction.rowIcon" size="lg"></fa-icon>
        </div>

        <!-- Customer name (all breakpoints, with stacked date on mobile) -->
        <div class="tx-cell tx-name">
          <span data-test="transaction-cardholder-name" class="tx-name-text">{{
            transaction.cardHolderDetails.name || '-'
          }}</span>
          <span class="tx-name-sub">{{
            transaction.createdOn | date: 'dd/MM/yy HH:mm'
          }}</span>
        </div>

        <!-- Date (own column from md up) -->
        <div data-test="transaction-created-date" class="tx-cell tx-date">
          <span class="tx-date-day">{{
            transaction.createdOn | date: 'd MMM y'
          }}</span>
          <span class="tx-date-time"
            >At {{ transaction.createdOn | date: 'h:mm a' }}</span
          >
        </div>

        <!-- Card number (md and up) -->
        <span class="tx-cell tx-card" data-test="transaction-masked-card">{{
          transaction.rowCard
        }}</span>

        <!-- Amount -->
        <span class="tx-cell tx-amount" data-test="transaction-amount">{{
          transaction.amount | currency: transaction.currencyCountry
        }}</span>

        <!-- Status -->
        <odin-chip-status
          mat-list-icon
          class="tx-cell tx-status"
          [status]="transaction.formattedStatus"
          [chipClass]="transaction.statusIconClass"
        ></odin-chip-status>

        <!-- Chevron (kept close to status: both icon-scale cells) -->
        <div class="tx-cell tx-go">
          @if (allowSelection) {
            <div
              class="rounded-circle mon-text-white mon-bg-primary dark d-flex align-items-center justify-content-center"
            >
              <mat-icon matListItemIcon>arrow_forward</mat-icon>
            </div>
          }
        </div>
      </div>
      <mat-divider></mat-divider>
    </div>
    <div>
      <ng-content></ng-content>
    </div>
  </cdk-virtual-scroll-viewport>
  }
</div>
